import React from 'react'
import { useRanger } from 'react-ranger'
import { Box, Icon } from '@maui/elements'
import isObject from 'lodash/isObject'

export const UseRangeSlider = (options) => {
  if (!isObject(options)) {
    throw new Error('options must be an object')
  }
  const { getTrackProps, ticks, segments, handles } = useRanger(options)
  return {
    getTrackProps,
    ticks,
    segments,
    handles,
  }
}

export function RangeSlider({ getTrackProps, segments, handles }) {
  return (
    <Box
      display="inline-flex"
      height="8px"
      width= "100%"
      {...getTrackProps()}>
      {segments.map(({ getSegmentProps }, i) =>
        (
          <Box
            {...getSegmentProps()}
            index={i}
            backgroundColor={ i === 1 ? 'colorFillEmphasis' : 'colorFillDeemphasis' }
            height="4px"
            top="2px"
            key={i} />
        ))}
      { handles.map(({ value, active, getHandleProps }, i) => {
        return (
          <Box as="button" key={i}
            {...getHandleProps({
              style: {
                appearance: 'none',
                border: 'none',
                background: 'transparent',
                outline: 'none',
              },
            })}
          >
            <Box
              backgroundColor="colorBackgroundOverlay"
              display="flex"
              alignItems="center"
              justifyContent="center"
              width="1.6rem"
              height="1.6rem"
              borderRadius="100%"
              fontSize="0.7rem"
              whiteSpace="nowrap"
              color="white"
              cursor="pointer"
              active={active}
              _hover={{
                borderColor: 'colorActionSecondaryDefault',
                borderStyle: 'solid',
              }}
            >
              <Icon name="grip-vertical" size="sm"/>
            </Box>
          </Box>
        )
      })}
    </Box>
  )
}
